import { useLanguage } from '../../context/LanguageContext';
import { valouseTranslations } from '../../translations/valouseTranslations';

const InteriorSection = () => {
  const { language } = useLanguage();
  const t = (obj) => obj[language] || obj['fr'];
  const tr = valouseTranslations;

  return (
    <section id="interieur" className="py-16 sm:py-24 px-6 bg-[#8d7a6b]">
      <div className="max-w-2xl mx-auto text-center space-y-8 text-[#F3E5CF]">
        
        {/* Premium micro-heading structure */}
        <div className="space-y-3">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#3F2A24]">
            {t(tr.interior.contextLine)}
          </p>
          <h2 
            className="font-serif text-2xl sm:text-3xl md:text-4xl text-[#F3E5CF]"
            style={{ textWrap: 'balance' }}
          >
            {t(tr.interior.title)}
          </h2>
          <p 
            className="font-serif text-sm sm:text-base text-[#F3E5CF]/70 italic"
            style={{ textWrap: 'balance' }}
          >
            {t(tr.interior.poeticLine)}
          </p>
        </div>
        
        <div className="w-16 h-[1px] bg-[#3F2A24]/50 mx-auto" />
        
        <div className="space-y-6 text-base sm:text-lg leading-[1.9]">
          <div className="space-y-2">
            <p style={{ textWrap: 'balance' }}>
              {t(tr.interior.p1)}
            </p>
            <p style={{ textWrap: 'balance' }}>
              Tu <span className="font-semibold">participes</span>.
            </p>
          </div>
          
          <div className="space-y-2">
            <p style={{ textWrap: 'balance' }}>
              {t(tr.interior.p3)}
            </p>
            <p style={{ textWrap: 'balance' }}>
              Tu <span className="font-semibold">traverses</span>.
            </p>
          </div>
          
          <div className="pt-4 space-y-3">
            <p style={{ textWrap: 'balance' }}>
              {t(tr.interior.p5)}
            </p>
            <p style={{ textWrap: 'balance' }}>
              {t(tr.interior.p6)}
            </p>
            <p style={{ textWrap: 'balance' }}>
              {t(tr.interior.p7)}
            </p>
            <p style={{ textWrap: 'balance' }}>
              {t(tr.interior.p8)}
            </p>
            <p style={{ textWrap: 'balance' }}>
              {t(tr.interior.p9)}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InteriorSection;
